import React from 'react';

function RecievedMessageBubble ({messageText}){
    return(
    <div className='recievedMessageContainer'>
      <img className="userImage" src="https://campaigns.xpressinformation.co.za/AvbobImages/avbob-logo-dark-green.png"></img>
      <div className="recievedMessageBubble">
        {/* {messageText} */}
        <div dangerouslySetInnerHTML={{ __html: messageText }}/>
        
      </div>
    </div>
    );
}

export default RecievedMessageBubble;